const employerMenu = [
  {
    id: 1,
    name: "Inicio",
    icon: "la-home",
    routePath: "/dashboard",
    active: "active",
  },
  {
    id: 2,
    name: "Mi perfil",
    icon: "la-user-tie",
    routePath: "/my-profile",
    active: "",
  },
  {
    id: 4,
    name: "Pedidos",
    icon: "la-briefcase",
    routePath: "/orders",
    active: "",
  },
  {
    id: 9,
    name: "Mensajes",
    icon: "la-comment-o",
    routePath: "/messages",
    active: "",
  },
  {
    id: 10,
    name: "Cambiar Contraseña",
    icon: "la-lock",
    routePath: "/change-password",
    active: "",
  },
  {
    id: 11,
    name: "Logout",
    icon: "la-sign-out",
    routePath: "/",
    active: "",
  },
  {
    id: 12,
    name: "Eliminar Perfil",
    icon: "la-trash",
    routePath: "/",
    active: "",
  },
];
export default employerMenu;
